import React, { useEffect, useState } from "react";
import { FiFilter } from "react-icons/fi";
import Scrollbar from "../../scrollbar";
import { FaCalendar } from "react-icons/fa";
import { useAppDispatch, useAppSelector } from "../../../utils/redux/hooks";
import { RootState } from "../../../utils/redux/store";
import { addisLoading, addnotifications } from "../../../utils/redux/mainSlice";
import { getNotifications } from "../../../utils/apis/func";
import EmptyState from "../emptyState";

const AllNotifications = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const notifications = useAppSelector(
    (store: RootState) => store.user.notifications
  );

  const itemsPerPage = 15;
  const totalItems = notifications?.length;

  const allItems = Array.from({ length: itemsPerPage }, (_, index) => ({
    id: index + 1,
    date: `16 Sep 2023 13:56`,
    role: `customer`,
    name: `Oluwarotimi Ogooluwa`,
    content: `Order Dispute: Customer did not ...`,
  }));

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
  const itemsToShow = notifications?.slice(startIndex, endIndex);

  const handlePrevPageClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPageClick = () => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const [calenderFrom, setcalenderFrom] = useState(false);
  const [calenderTo, setcalenderTo] = useState(false);

  console.log(notifications);

  const dispatch = useAppDispatch();

  useEffect(() => {
    const fetchNotifications = async () => {
      dispatch(addisLoading(true));
      const res: any = await getNotifications("");
      // console.log(res);
      if (res?.status === 200 || res?.status === 201) {
        dispatch(addnotifications(res?.data?.data));
      }
      dispatch(addisLoading(false));
    };

    fetchNotifications();
  }, [dispatch]);

  return (
    <div className="px-6">
      <div className="flex justify-between  ">
        <p className="text-[#88087B] font-roboto text-3xl font-medium leading-normal">
          All Notifications
        </p>
        <div className=" bg-[#88087B] rounded-md p-2">
          <FiFilter size={26} className="text-[#fff] " />
        </div>
      </div>
      <div className="shadow-lg rounded-lg py-2 my-4  w-full xl:w-full bg-white flex flex-row px-2 lg:px-[2.5%] ">
        <div className="flex items-center">
          <p className="text-[#88087B] font-roboto text-sm">From</p>
          <div
            className="border border-[#88087B] py-1.5 px-3 ml-4 items-center flex"
            onClick={() => {
              setcalenderFrom(!calenderFrom);
              setcalenderTo(false);
            }}
          >
            <FaCalendar size={20} className="text-[#BDBDBD] mr-4" />
            <p className="text-[#000000] font-roboto sm:text-[0.4rem] xl:text-sm">
              01 Sep 2023
            </p>
          </div>
        </div>

        <div className="flex items-center sm:ml-[3vw] xl:ml-[10%]">
          <p className="text-[#88087B] font-roboto text-sm">To</p>
          <div
            className="border border-[#88087B] py-1.5 px-3 ml-4  flex items-center"
            onClick={() => {
              setcalenderTo(!calenderTo);
              setcalenderFrom(false);
            }}
          >
            <FaCalendar size={20} className="text-[#BDBDBD] mr-4" />
            <p className="text-[#000000] font-roboto sm:text-[0.4rem] xl:text-sm">
              01 Sep 2023
            </p>
          </div>
        </div>

        <button
          onClick={() => {}}
          className="sm:ml-[2.5vw] xl:ml-[10%]  xl:w-[5.5vw] w-1/6 rounded-lg py-3 px-2 lg:px-4 bg-[#88087B]"
        >
          <p className="text-[#ffffff] text-center mx-auto font-roboto text-sm">
            Go
          </p>
        </button>
      </div>

      <section className="mt-2">
        <div className="overflow-hidden rounded-t-lg">
          <table className="w-full">
            <thead className="bg-[#88087B] text-[#F7F7F7] font-roboto text-lg font-medium">
              <tr>
                <th className="py-3">Date</th>
                <th className="py-3">Role</th>
                <th className="py-3">Name</th>
                <th className="py-3">Content</th>
              </tr>
            </thead>
            <tbody>
              {itemsToShow.map((item) => (
                <tr
                  key={item.id}
                  className="hover:bg-[#87878d] transition duration-300 font-roboto text-xs font-medium leading-normal border border-b-[#525050] text-center"
                >
                  <td className="py-4">{item?.createdAt}</td>
                  <td className="py-4">{item?.user?.accountType}</td>
                  <td className="py-4">{item?.title}</td>
                  <td className="py-4">{item?.message}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {itemsToShow?.length < 1 && (
          // <section>
          //   <div className="container flex flex-wrap justify-between items-center mx-auto bg-white rounded-md dark:bg-slate-500">
          //     <div className="text-center border-dashed border-2 border-slate-200 dark:border-slate-100 rounded-md w-full p-20">
          //       <i className="bx bxs-contact bx-lg mb-5 dark:text-white"></i>
          //       <p className="sm:text-md lg:text-xl mb-2 uppercase font-bold dark:text-white">
          //         No Notifications
          //       </p>
          //       <span className="sm:text-sm lg:text-m text-slate-400 block mb-10 dark:text-slate-50">
          //         Your notifications would be displayed here
          //       </span>
          //       {/* <button className="bg-blue-400 rounded-full px-5 py-3 text-white hover:bg-blue-500 w-52">
          //         Create
          //       </button> */}
          //     </div>
          //   </div>
          // </section>
          <EmptyState
            title={"No Notifications"}
            text={"Your notifications would be displayed here"}
          />
        )}
        <div className="flex justify-end px-4 mt-8 -mb-8">
          <p className="bg-[#88087B] border border-[#88087B] px-2 rounded-md text-[#FFCD1E] text-center text-shadow font-roboto text-base font-medium leading-normal">
            Export
          </p>
        </div>
        <Scrollbar
          currentPage={currentPage}
          totalPages={Math.ceil(totalItems / itemsPerPage)}
          itemsPerPage={itemsPerPage}
          totalItems={totalItems}
          onPrevPageClick={handlePrevPageClick}
          onNextPageClick={handleNextPageClick}
        />
      </section>
    </div>
  );
};

export default AllNotifications;
